<template>
  <el-dialog
    :destroy-on-close="true"
    :custom-class="'custom-dlg'"
    :title="`预览`"
    :visible.sync="show"
    width="540">
    <div class="d-flex center">
      <iframe
        v-if="url"
        ref="frame"
        :src="url"
        frameborder="0"
        :width="width"
        :height="height"
        class="frame-style"
      ></iframe>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Frame',
  data() {
    return {
      show: false,
      width: 0,
      height: 0,
      url: null
    }
  },
  methods: {
    open(data, size) {
      this.show = true
      this.url = `${window.location.origin}${this.$utils.siteBase()}previewSmartTag/index.html`
      this.renderFrame(data, size)
    },
    renderFrame(data, size) {
      const {
        frame
      } = this.$refs
      
      const sizeConfig = size.split('x')
      const width = sizeConfig[0] ? Number(sizeConfig[0]) : 0
      const height = sizeConfig[1] ? Number(sizeConfig[1]) : 0
      this.width = width + 40
      this.height = height + 20

      if (frame) {
        frame.contentWindow.p = data
      } else {
        setTimeout(() => {
          this.renderFrame(data, size)
        }, 100)
      }
    }
  }
}
</script>

<style scope lang="scss">
  // .frame-style {
  //   width: 100%;
  //   height: 100%;
  // }
  .custom-dlg {
    background-color: #e0e0e0;
  }
</style>